import { ITokenStorage } from "../../contexts/Types";

export function getTokenFromStorage() {
  let result: ITokenStorage = {
    access_token: "",
    refresh_token: "",
    session_token: null,
  };
  const tokenStorage = localStorage.getItem("token");
  if (tokenStorage) {
    const token: ITokenStorage = JSON.parse(tokenStorage);
    result = token;
  }
  return result;
}

export function getSessionTokenDecoded() {
  const { session_token } = getTokenFromStorage();
  return session_token;
}
